import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Login from '../Login/Login';
import ResetPassword from '../ResetPassword/ResetPassword';
import './styles.css';
import { useAuthStatus, useSessionStoreLoading } from '../../store/hooks';

const block = 'auth-page';

const AuthContainer: React.FC = () => {
  const isLoggedIn = useAuthStatus();
  const isLoading = useSessionStoreLoading();

  if (!isLoading && isLoggedIn) {
    return <Redirect to="/admin" />;
  }

  return (
    <div className={block}>
      <div className={`${block}__content`}>
        <Route
          path="/auth"
          exact={true}
          render={() => <Redirect to="/auth/login" />}
        />
        <Route path="/auth/login" component={Login} />
        <Route path="/auth/reset_password" component={ResetPassword} />
        {/*<Route path="/auth/restore/:code" component={RestorePassword} />*/}
      </div>
    </div>
  );
};

export default AuthContainer;
